import ko from 'knockout';

ko.observable.fn.revertable = function() {
    const self = this;
    let originalValue = self();

    self.commit = function() {
        originalValue = self();
    };

    self.revert = function() {
        self(originalValue);
    };

    self.isDirty = function() {
        return self() !== originalValue;
    };

    return self;
};
